var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconDrag(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "14px",
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uD83D\\uDDFF",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-Guide",
    transform: "translate(-72.000000, -1692.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Stacked-Group-2",
    transform: "translate(63.000000, 199.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon/drag",
    transform: "translate(4.000000, 1488.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5,5 L7,5 L7,7 L5,7 L5,5 Z M9,5 L11,5 L11,7 L9,7 L9,5 Z M13,5 L15,5 L15,7 L13,7 L13,5 Z M17,5 L19,5 L19,7 L17,7 L17,5 Z M5,9 L7,9 L7,11 L5,11 L5,9 Z M9,9 L11,9 L11,11 L9,11 L9,9 Z M13,9 L15,9 L15,11 L13,11 L13,9 Z M17,9 L19,9 L19,11 L17,11 L17,9 Z M5,13 L7,13 L7,15 L5,15 L5,13 Z M9,13 L11,13 L11,15 L9,15 L9,13 Z M13,13 L15,13 L15,15 L13,15 L13,13 Z M17,13 L19,13 L19,15 L17,15 L17,13 Z M5,17 L7,17 L7,19 L5,19 L5,17 Z M9,17 L11,17 L11,19 L9,19 L9,17 Z M13,17 L15,17 L15,19 L13,19 L13,17 Z M17,17 L19,17 L19,19 L17,19 L17,17 Z",
    id: "Fill",
    fill: "#858199",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "bound",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDrag);
export default __webpack_public_path__ + "static/media/iconDrag.64a89462.svg";
export { ForwardRef as ReactComponent };